import React, {Component} from 'react';
import {EditMetricConversionConfigurationModal} from "./EditMetricConversionConfigurationModal";
import {FaIcon} from "../../FaIcon";

export class EditMetricConversionConfigurationModalButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.handleSuccessfulEdited = this.handleSuccessfulEdited.bind(this);
    }

    handleSuccessfulEdited(conversionType, actionIdsSelectedByBuccId) {
        this.props.onMetricConversionConfigurationEdited(conversionType, actionIdsSelectedByBuccId);
    }

    render() {
        return (
            <span>
                <button className="edit-button" onClick={(event) => {
                    event.preventDefault();
                    this.editMetricConversionConfigurationModal.toggle()
                }}><FaIcon iconName={"pencil-alt"}/></button>
                <EditMetricConversionConfigurationModal ref={instance => {this.editMetricConversionConfigurationModal = instance;}}
                                                        afterSuccessfulEdited={this.handleSuccessfulEdited}
                                                        actionIdsSelectedByBuccId={this.props.actionIdsSelectedByBuccId}
                                                        adAccountsActionData={this.props.adAccountsActionData}
                                                        conversionType={this.props.conversionType}
                />
            </span>
        );
    }
}
